import { useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

export type AuditAction = "accessed" | "created" | "edited" | "deleted" | "restored" | "permanent_deleted" | "downloaded";
export type AuditResourceType = "report" | "dashboard" | "chat" | "workflow" | "query";

interface LogParams {
  action: AuditAction;
  resourceType: AuditResourceType;
  resourceId?: string;
  resourceName?: string;
  metadata?: Record<string, unknown>;
}

export function useAuditLog() {
  const { user, profile } = useAuth();

  const log = useCallback(
    async ({ action, resourceType, resourceId, resourceName, metadata }: LogParams) => {
      if (!user || !profile?.client_id) return;

      try {
        await (supabase.from("audit_logs") as any).insert({
          client_id: profile.client_id,
          user_id: user.id,
          user_email: user.email ?? null,
          user_name: profile.full_name ?? null,
          action,
          resource_type: resourceType,
          resource_id: resourceId ?? null,
          resource_name: resourceName ?? null,
          metadata: metadata ?? {},
        });
      } catch {
        // Audit logging is best-effort; never block the user
      }
    },
    [user, profile],
  );

  return { log };
}
